import { gql } from "__generated__/gql";

export const demurrageCharter_query = gql(`#graphql
	query demurrageCharter($id: Long!) {
		charter(id: $id) {
			id
			type
			subtype
			charterNumber
			totalLaytime
			totalCleaningLaytime
			totalLoadingLaytime
			totalDischargingLaytime
			totalNitrogenPurgingLaytime
			laytimeRemarks
			excessLaytime
			demurrage
			contract {
				id
				currency {
					isoCode
				}
				agreements {
					...agreementFragment
				}
			}
			laytimeCalculations {
				...laytimeCalculationFragment
			}
			declarations {
				id
				invoiceGroupType {
					id
				}
				lastStatusChange {
					...statusChangeFragment
				}
				statusChanges {
					...statusChangeFragment
				}
				invoiceLines {
					id
					quantity
					price {
						currency {
							isoCode
							symbol
						}
						value
					}
				}
				declarationValues {
					id
					agreement {
						id
						calculateAmount(charterId: $id)
					}
					price
					quantity
				}
			}
		}
	}
`);

export const suggestLaytime_query = gql(`#graphql
	query suggestLaytime_demurrageDetails($charterId: Long!, $agreementId: Long!) {
		suggestLaytime(charterId: $charterId, agreementId: $agreementId) {
			cleaningLaytime
			loadingLaytime
			dischargingLaytime
			nitrogenPurgingLaytime
			totalLaytime
		}
	}
`);

export const updateLaytimeAndDeclare_mutation = gql(`#graphql
	mutation updateLaytimeAndDeclare($charterId: Long! $input: LaytimeInput!) {
		updateLaytimeAndDeclare(charterId: $charterId, input: $input)
	}
`);

export const demurrageDocumentsVoyage_query = gql(`#graphql
	query demurrageDocumentsVoyage($voyageId: Long!) {
		voyage(id: $voyageId) {
			...VoyageDocumentsVoyage
			cargos {
				statusChanges {
					...statusChangeFragment
				}
				lastStatusChange {
					...statusChangeFragment
				}
			}
			ship {
				id
				name
				capacityTon
			}
			documents {
				id
			}
		}
	}
`);
